import { leftGame } from "@/store/globalSlice"
import type { AppDispatch } from "@/store/store"
import { resetGameTimers } from "./gameTimers"
import { getUserCreds, socket } from "./utils"

/**
 * Leaving a game, from wherever the button is pressed. One routine because
 * "leave" has to mean the same thing every time, and it means three things:
 *
 *  - the server hands the seat to a bot and takes this socket out of the game's
 *    room, so the table's traffic stops arriving;
 *  - the store forgets the game, which is what stops the App-level socket
 *    handlers, the toast container and the end-game modal — none of which live
 *    under the game route — from drawing a game we walked out of;
 *  - the player lands in the lobby.
 *
 * The store is cleared straight away rather than waiting for the server, so
 * anything already in flight (a turn sound, a "player left" toast) has nothing
 * left to render against by the time it arrives.
 */
export const leaveGame = (
  game: IGameDetails | undefined,
  dispatch: AppDispatch
) => {
  const gameId = game?.id || ""
  const playerOrder = game?.situation?.players.find(
    (player) => player.id === getUserCreds().email
  )?.order as PlayerOrder

  socket.emit("game.disconnect-player", gameId, playerOrder)
  // The countdowns are kept outside the store (utils/gameTimers), so clearing
  // the store does not clear them — this is their half of the same sweep.
  resetGameTimers()
  dispatch(leftGame(gameId))
}
